import React from 'react';
import { BsXLg } from 'react-icons/bs';

const ConfirmDownload = ({ setConfirmDownload }) => {
  return (
    <div className="modalWrap">
      <div className="modalBody appBox">
        <div className="modTitle">
          <h2>다운로드 신청 완료</h2>
        </div>
        <div className="salutation">
          <p>
            신청하신 자료는 담당자 확인 후,
            <br />
            기입하신 연락처로 전달 드리겠습니다.
            <br />
            감사합니다.
          </p>
          <button type="button" onClick={() => setConfirmDownload(false)}>
            확인
          </button>
        </div>
        <div className="closeBtn positionAdj">
          <button type="button" onClick={() => setConfirmDownload(false)}>
            <BsXLg />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDownload;
